import React from 'react';
import * as Styled from './styled';
import { ILSchoolGroupsSummary } from 'store/state/selectors/insights/schools/types';
import { useLocale, ITranslate } from 'locale';
import { Pagination } from 'ds/components/pagination';
import Card from '../card';


interface SchoolListProps {
  schools: ILSchoolGroupsSummary;
  hoveredSchoolId: string | null;
  setHoveredSchoolId: (id: string) => void;
}

const createLabels = (supervision: string, classRange: string, t: ITranslate) => {
  return [ supervision ? t('schoolPage.sectors.map', { value: supervision }) : null, classRange ].filter(Boolean);
};

export const SchoolList: React.FC<SchoolListProps> = (props) => {
  const {
    schools,
    hoveredSchoolId,
    setHoveredSchoolId,
  } = props;

  const { t } = useLocale();

  const totalElementaryPages = Math.ceil(schools.ELEMENTARY.length / 5);
  const [ currentElementaryPage, setCurrentElementaryPage ] = React.useState(1);
  const elementarySchoolsToShow = schools.ELEMENTARY.slice((currentElementaryPage - 1) * 5, currentElementaryPage * 5);

  const totalHighPages = Math.ceil(schools.HIGHSCHOOL.length / 5);
  const [ currentHighPage, setCurrentHighPage ] = React.useState(1);
  const highSchoolsToShow = schools.HIGHSCHOOL.slice((currentHighPage - 1) * 5, currentHighPage * 5);

  return (
    <Styled.Root>
      <Styled.Title weight="bold">{t('widgetTitle.schools.list', { count: schools.ELEMENTARY.length, level: 'ELEMENTARY' })}</Styled.Title>
      {elementarySchoolsToShow.map(({ schoolId, schoolName, settlement, address, supervision, classRange }) => (
        <Card
          key={schoolId}
          schoolId={schoolId}
          title={schoolName}
          subtitle={[ address, settlement ].join(', ').toString()}
          labels={createLabels(supervision, classRange, t)}
          onMouseEnter={() => setHoveredSchoolId(schoolId)}
          onMouseLeave={() => setHoveredSchoolId(null)}
          isHovered={hoveredSchoolId === schoolId}
        />
      ))}
      {totalElementaryPages > 1 ? (
        <Pagination
          totalPages={totalElementaryPages}
          onSetActivePage={setCurrentElementaryPage}
          activePage={currentElementaryPage}
          paginationType={'pages'}
        />
      ) : null}
      <Styled.Title weight="bold">{t('widgetTitle.schools.list', { count: schools.HIGHSCHOOL.length, level: 'HIGHSCHOOL' })}</Styled.Title>
      {highSchoolsToShow.map(({ schoolId, schoolName, address, settlement, supervision, classRange, madlanEducationIndexInstitutional, madlanEducationIndexCityAverage, madlanEducationIndexNationalAverage }) => (
        <Card
          withScore
          key={schoolId}
          title={schoolName}
          subtitle={[ address, settlement ].join(', ').toString()}
          schoolId={schoolId}
          isHovered={hoveredSchoolId === schoolId}
          onMouseEnter={() => setHoveredSchoolId(schoolId)}
          onMouseLeave={() => setHoveredSchoolId(null)}
          labels={createLabels(supervision, classRange, t)}
          madlanEducationIndexInstitutional={madlanEducationIndexInstitutional}
          madlanEducationIndexCityAverage={madlanEducationIndexCityAverage}
          madlanEducationIndexNationalAverage={madlanEducationIndexNationalAverage}
        />
      ))}
      {totalHighPages > 1 ? (
        <Pagination
          totalPages={totalHighPages}
          onSetActivePage={setCurrentHighPage}
          activePage={currentHighPage}
          paginationType={'pages'}
        />
      ) : null}
    </Styled.Root>
  );
};
